var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSmartphoneDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 2H11.8C11.4684 2 11.2 2.26841 11.2 2.6C11.2 2.93159 11.4684 3.2 11.8 3.2H14.2C14.5315 3.2 14.8 2.93159 14.8 2.6C14.8 2.26841 14.5315 2 14.2 2Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 0H7.20005C5.87686 0 4.80005 1.07681 4.80005 2.4V21.6C4.80005 22.9232 5.87686 24 7.20005 24H16.8C18.1232 24 19.2 22.9232 19.2 21.6V2.4C19.2 1.07681 18.1232 0 16.8 0ZM18 21.6C18 22.2628 17.4629 22.8 16.8 22.8H7.20005C6.53724 22.8 6.00005 22.2628 6.00005 21.6V2.4C6.00005 1.73719 6.53724 1.2 7.20005 1.2H16.8C17.4629 1.2 18 1.73719 18 2.4V21.6Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.0001C12.6628 22.0001 13.2 21.4628 13.2 20.8001C13.2 20.1374 12.6628 19.6001 12 19.6001C11.3373 19.6001 10.8 20.1374 10.8 20.8001C10.8 21.4628 11.3373 22.0001 12 22.0001Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79995 3.2C10.1313 3.2 10.4 2.93137 10.4 2.6C10.4 2.26863 10.1313 2 9.79995 2C9.46858 2 9.19995 2.26863 9.19995 2.6C9.19995 2.93137 9.46858 3.2 9.79995 3.2Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSmartphoneDark);
export default __webpack_public_path__ + "static/media/ic-smartphone-dark.5ed81b64fff29fcf4469d054c8579d76.svg";
export { ForwardRef as ReactComponent };